// sort-imports-ignore
// import order of normalize and App is important here for css priorities
import 'normalize.css';
import '@volvo/vcdk/themes/volvo/semantic-light.css';
import { createRoot } from 'react-dom/client';

import App from './App';
import './JSONDateExtensions';

createRoot(document.getElementById('root')!).render(<App />);
